import { render, staticRenderFns } from "./whyChooseUs.vue?vue&type=template&id=e264d222&"
import script from "./whyChooseUs.vue?vue&type=script&lang=js&"
export * from "./whyChooseUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports